import { useEffect, useState } from 'react';
import { ReactComponent as GrabZone } from './img/bx-grid-vertical.svg';
import { ReactComponent as PlusGreen } from './img/plus_green.svg';
import { ButtonBasic, Sceleton } from '@lk-gtcom/ecomlab-components';
import { ButtonActionDrop } from '../../../components/Buttons/ButtonActionDrop/ButtonActionDrop';
import no_task from './img/no-tasks.svg';
import TaskItem from '../TaskItem/TaskItem';
import { ModalSelectedColorColumn } from '../Modal/ModalSelectedColorColumn/ModalSelectedColorColumn';
import finally_icon from './img/finally.svg'
import { useRef } from 'react';
import { TooltipBlack } from '../../../components/Tooltip/TooltipBlack/TooltipBlack';
import './ColumnTask.scss';

const ColumnTask = ({
  // Общие пропсы
  isShowAuthor,
  projectName,
  author,
  email,
  actual,
  task_permissible = [],
  searchValue,
  isVisibleCheckbox,
  listPrint,
  setListPrint,

  // Навигация и роутинг
  fetchProjectToRedirect,
  openTask,

  // Данные проекта
  currentBord,
  search,
  isModal,
  crm = false,
  ticket = false,
  task = false,

  // Управление колонками
  col,
  refHeader,
  refContainer,
  refsTotal,
  setSelectedColumn,
  setGeneralTotal,
  setCountCol,

  // Drag and drop
  dragStartColumn,
  dragOverHandler,
  setIsOver,
  dropCardHandler,
  dragStartHandler,

  // Редактирование колонок
  isEditCol,
  setIsEditCol,
  setIsBlockKey,
  changeTaskListName,
  columnNameIsUpdating,
  setCurrentColumn,
  setIsModalStatus,
  setRemovableTaskList,
  setIsModalDeleteCol,
  openModal,

  // Управление задачами
  taskId,
  fetchDeleteTask,
  isOpenActiveMenu,
  setIsOpenActiveMenu,

  // Фильтры
  selectedExecutor,
  selectedAuthor,
  selectedCoExecutor,
  selectedStatus,
  body,
  headers,

  // Обновление данных
  actualId,
  setActualId,
  updateId,
  setUpdateId,
  isUpdateDataColumnList
}) => {

  // Состояния для данных колонки
  const [taskList, setTaskList] = useState([]);
  const [taskTotal, setTaskTotal] = useState(0);
  const [countTask, setCountTask] = useState([]);
  const [loading, setLoading] = useState(false);
  const [load, setLoad] = useState(false);

  // Состояния для бесконечной прокрутки
  const [taskPage, setTaskPage] = useState(1);
  const [taskPageHeight, setTaskPageHeight] = useState(0);
  const [taskPageScrollTop, setTaskPageScrollTop] = useState(-1);
  const [taskIsSearchLastPage, setTaskIsSearchLastPage] = useState(false);

  // Состояния UI
  const [isUpdateDataColumn, setIsUpdateColumn] = useState(false);
  const [isModalSetColor, setIsModalSetColor] = useState(false);
  const [draggingTaskId, setDraggingTaskId] = useState(null);

  // Refs
  const taskRef = useRef();

  // Корректные переменнные
  const currentColId = task ? col?.typeId : col?.id

  const btns = [
    ...crm ? [{
      btn: 'Настройки',
      func: (e) => {
        setCurrentColumn(col);
        setIsModalStatus(true);
      },
    }] : [],
    {
      btn: 'Установить цвет',
      func: (e) => {
        setIsModalSetColor(true)
      },
    },
    {
      btn: 'Удалить', func: (e) => {
        setRemovableTaskList(col);
        setIsModalDeleteCol(true);
      }
    },
  ];

  const onScroll = (listRef, setPageHeight, setScrollTop) => {
    const { scrollTop, scrollHeight, clientHeight } = listRef.current;
    const bottomHeight = scrollHeight - clientHeight;
    if (bottomHeight) {
      setPageHeight(bottomHeight);
    }
    setScrollTop(scrollTop);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      const currentPageHeight = taskPageHeight;
      if (
        !taskIsSearchLastPage &&
        Math.ceil(taskPageScrollTop) >= currentPageHeight &&
        taskList?.length > 0
      ) {
        setTaskPage((prev) => prev + 1);
        return;
      }
    }, 500);
    return () => clearTimeout(timeout);
  }, [taskPageScrollTop, taskPageHeight, taskIsSearchLastPage, countTask]);

  useEffect(() => {
    setTaskPage(1);
  }, []);

  useEffect(() => {
    if (taskPage > 1) {
      setLoading(true)
    }
  }, [taskPage]);

  // Получение колонок
  const fetchProjects = (type = col.id, abortController = new AbortController()) => {
    if (!taskId) return;
    setLoad(true)

    let url, urlsByEmployee;
    if (ticket) {
      url = ` https://portals.ecomru.ru/api/ticket/ticket/step/${type}`
      urlsByEmployee = ` https://portals.ecomru.ru/api/ticket/project/projects/deals`
    }
    if (crm) {
      url = ` https://portals.ecomru.ru/api/crm/deals/step/${type}`
      urlsByEmployee = ` https://portals.ecomru.ru/api/crm/projects/projects/deals`
    }
    if (task) {
      url = ` https://portals.ecomru.ru/api/v3/tasks/get_event_by_column`;
      urlsByEmployee = ` https://portals.ecomru.ru/api/v3/tasks/get_event_by_column`
    }

    const executor = selectedExecutor?.length > 0 ? { responsible_list: selectedExecutor } : {};
    const author = selectedAuthor?.length > 0 ? { author_list: selectedAuthor } : {};
    const co_executor = selectedCoExecutor?.length > 0 ? { co_executors_list: selectedCoExecutor } : {};
    const projectId = taskId == -1 ? { project_id: type } : {};
    const taskType =
      selectedStatus?.length > 0
        ? { task_type: selectedStatus?.map(({ value }) => value) }
        : {};
    const step_id_list = selectedStatus?.length > 0
      ? { step_id_list: selectedStatus?.map(({ value }) => value) }
      : {};

    const bodyy = JSON.stringify({
      project_id: +taskId,
      ...executor,
      ...co_executor,
      ...author,
      ...taskType,  // для задач
      ...body,
      ...task ? {} : projectId,
      column_id: type, // для задач
      limit: 20,
      page: taskPage,
      ...step_id_list
    });

    fetch(taskId == -1 ? urlsByEmployee : url, {
      body: bodyy,
      method: 'POST',
      headers,
      signal: abortController.signal,
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error('bad events response');
        }
      })
      .then((json) => {
        const { total, data, events } = json;

        if (Array.isArray(data) || data === null) {
          if (taskPage > 1) {
            setTaskList((prev) => [...prev, ...data || []])
          } else {
            setTaskList(data || [])
          }
        }

        if (Array.isArray(events) || events === null) {
          if (taskPage > 1) {
            setTaskList((prev) => [...prev, ...events]);
          } else {
            setTaskList(events);
          }
        }
        setTaskTotal(total);
        setGeneralTotal(prev => prev + (total ? total : 0))
        setCountCol(prev => prev + 1)
        setTaskIsSearchLastPage(total < taskPage * 20);
        setLoad(false)
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoading(false)
        setLoad(false);
      });
  };

  // Каунтер для сделок
  const fetchGetCount = (type = col.id, abortController = new AbortController()) => {
    let url = ` https://portals.ecomru.ru/api/crm/deals/task_list/data`

    const executor = selectedExecutor?.length > 0 ? { responsible_list: selectedExecutor } : {};
    const author = selectedAuthor?.length > 0 ? { author_list: selectedAuthor } : {};
    const co_executor = selectedCoExecutor?.length > 0 ? { co_executors_list: selectedCoExecutor } : {};


    const body = JSON.stringify({
      ...executor,
      ...co_executor,
      ...author,
      funnel_id: currentBord?.id,
      search
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error('bad events response');
        }
      })
      .then((json) => {
        if (Array.isArray(json)) {
          setCountTask(json)
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => { });
  };

  useEffect(() => {
    if (!isModal && crm) {
      fetchGetCount()
    }
  }, [
    selectedExecutor,
    selectedCoExecutor,
    selectedAuthor,
    search,
    currentBord,
    isModal
  ]);

  useEffect(() => {
    if (typeof currentColId == 'number') {
      setTimeout(() => {
        fetchProjects(currentColId)
      }, 1000)
    }
  }, [
    taskPage,
    isUpdateDataColumn,
    isUpdateDataColumnList,
    searchValue,
    body?.order_direction,
    body?.order_field,
    body?.unviewed,
    body?.on_trash,
    selectedExecutor,
    selectedCoExecutor,
    selectedAuthor
  ]);

  useEffect(() => {
    if (updateId && (currentColId == updateId)) {
      setIsUpdateColumn(!isUpdateDataColumn)
      setUpdateId(null)
    }
  }, [updateId]);

  useEffect(() => {
    if (actualId && (currentColId == actualId)) {
      setIsUpdateColumn(!isUpdateDataColumn)
      setActualId(null)
    }
  }, [actualId]);

  const updateCol = () => {
    setUpdateId(currentColId)
  }

  return (
    <>
      {isModalSetColor && <ModalSelectedColorColumn
        id={currentColId}
        color={col?.color}
        setIsModal={setIsModalSetColor}
        updateCol={updateCol}
        crm={crm}
        ticket={ticket}
        task={task}
      />}

      <div
        column='true'
        draggable={(author?.login == email) ? true : false}
        className='col-task'
        onDragStart={e => {
          e.stopPropagation()
          dragStartColumn(e, col)
        }}
        onDragOver={e => dragOverHandler(e)}
        onDragEnd={(e) => {
          if (actual?.taskType?.id !== currentColId) {
            setIsUpdateColumn(!isUpdateDataColumn)
          }
        }}
        onDrop={e => {
          if (actual) {
            setActualId(actual?.typeId)
            setUpdateId(currentColId)
            dropCardHandler(e, col)
            setIsOver(false)
          }
        }}
      >
        <div
          className='col-task__header'
          tabIndex={5}
          style={{ background: col?.color || '' }}
        // onClick={(e) => navigate(`../task-list/${col.typeId}`)}
        // сделать переход по клику
        >
          <div
            ref={refHeader}
            className='col-task__white'
          >
            <div className='col-task__header-top'>
              {author?.login == email &&
                <GrabZone
                  className='col-task__drop-icon' />}

              {col?.done && <img src={finally_icon} />}

              {((author?.login !== email)) ?
                <TooltipBlack
                  child={<p
                    className='col-task__title-col'
                    onClick={(e) => {
                      setIsEditCol(col)
                    }}
                  >{task ? col.typeName : col.name}</p>}
                  text={task ? col.typeName : col.name}
                />
                :
                <textarea
                  className='col-task__input-col'
                  placeholder='Название'
                  type='text'
                  onFocus={(e) => setIsBlockKey(true)}
                  defaultValue={task ? col.typeName : col.name}
                  disabled={columnNameIsUpdating}
                  onBlur={e => {
                    setIsBlockKey(false)
                    if (task) {
                      changeTaskListName(col, e.target.value)
                    } else {
                      changeTaskListName(currentColId, e.target.value, col?.before)
                    }
                    refContainer?.current?.focus();
                  }}
                />}

              <div
                ref={(el) => (refsTotal.current[currentColId] = el)}
                className="col-task__count"
              >{taskTotal || 0}</div>

              {
                (+taskId !== -1 && !col?.done) &&
                author?.login == email &&
                task_permissible.includes(task ? col.typeName : col.name) == false
                &&
                <ButtonActionDrop
                  size='s'
                  id={col.id}
                  btns={btns} />
              }
            </div>
          </div>
          {
            <ButtonBasic
              text={<PlusGreen style={{ display: 'inline' }} />}
              width="100%"
              whiteGreen
              size="32px"
              onClick={() => {
                openModal(col);
              }}
              disabled={ticket}
            />
          }
        </div>

        <div
          style={{ background: col?.color || '' }}
          className="col-task__task-box"
          ref={taskRef}
          onScroll={(e) =>
            onScroll(taskRef, setTaskPageHeight, setTaskPageScrollTop)
          }
        >
          {((taskList?.length < 1 || !taskList) && !load) && (
            <div className="no-tasks" onClick={(e) => openModal(col)}>
              <img src={no_task} />
              <p className="text">Добавьте задачу</p>
            </div>
          )}

          {(load && !loading) ?
            <Sceleton
              height={'100%'}
              width={'100%'}
            />
            :
            taskList
              ?.map((_task, ind) => {
                // if (task) {
                const {
                  event_name,
                  priority,
                  end_time,
                  executor,
                  co_executor,
                  event_id,
                  task_type,
                  author,
                  link,
                  count_unread_comments,
                  step,

                  // crm, ticket
                  id,
                  name,
                  created_at,
                  responsible,
                } = _task;

                const currentCount = countTask.filter(({ deal_id }) => deal_id == id)?.[0]

                return (
                  <div
                    key={JSON.stringify(_task) + ind}
                    draggable={(taskId != -1) ? true : false}
                    onDragStart={(e) => {
                      e.stopPropagation();
                      setDraggingTaskId(task ? event_id : id);
                      dragStartHandler(e, _task);
                    }}
                    onDragEnd={() => setDraggingTaskId(null)}
                    onDragOver={(e) => dragOverHandler(e)}
                    onClick={(e) => {
                      let el = e.target;
                      setSelectedColumn(col)
                      if (!el.closest('.blackout')) {
                        openTask(e, task ? event_id : id, taskId, taskId);
                      }
                    }}
                    className={draggingTaskId === (task ? _task.event_id : _task.id) ? 'dragging-task' : ''}
                  >
                    <TaskItem
                      isVisibleCheckbox={isVisibleCheckbox} //чекбоксы для печати
                      isShowAuthor={isShowAuthor}
                      link={link}
                      author={author}
                      projectName={projectName}
                      projectId={taskId}
                      title={task ? event_name : name}
                      executor={task ? executor : responsible}
                      coExecutor={co_executor}
                      time={new Date(task ? end_time : created_at).toLocaleDateString('ru-RU', {
                        day: '2-digit',
                        month: 'numeric',
                        year: '2-digit',
                      })}
                      priority={priority}
                      openTask={(e) => openTask(e)}
                      isOpenActiveMenu={isOpenActiveMenu}
                      setIsOpenActiveMenu={(e) => setIsOpenActiveMenu(e)}
                      id={task ? event_id : id}
                      status={task ? task_type?.name : step?.name}
                      taskId={task ? taskId : id}
                      count_unread_comments={count_unread_comments}
                      deleteTask={e => {
                        fetchDeleteTask(e)
                        setUpdateId(currentColId)
                      }}
                      setListPrint={setListPrint}
                      listPrint={listPrint}
                      currentCount={currentCount}
                      crm={crm}
                      task={task}
                      ticket={ticket}
                      isTrash={body?.on_trash}
                      isUpdateColumn={isUpdateDataColumn}
                      setIsUpdateColumn={setIsUpdateColumn}
                    />
                  </div>
                )
              })
          }

          {(loading) && <div className="col-task__loader" >
            <Sceleton
              height={80}
              width={'100%'}
            />
          </div>}
        </div>
      </div>
    </>
  );
};

export { ColumnTask };
